import { Popover, PopoverContent, PopoverHandler } from '@material-tailwind/react'
import React, { useState } from 'react'
import { FaFilter } from 'react-icons/fa'
import { HiChevronUpDown } from 'react-icons/hi2'
import { ArrowReturnIcon } from '../../Assets/AllSvg'

const SubsFilterMenu = () => {
    const [openPopover, setOpenPopover] = useState(false);
    const [data, setData] = useState({
        price: false,
        created: false,
        status: false,
        method: false,
        cStatus: false,
        autoTax: false,
    })

    const handleRemove = () => {
        setData({ price: false, created: false, status: false, method: false, cStatus: false, autoTax: false, })
    }
    return (
        <div>
            <Popover open={openPopover} handler={setOpenPopover} placement='bottom-end'>
                <PopoverHandler>
                    <button className='input_focus_shadow h-[30px] rounded-[6px] sm:text-[14px] text-[12px] font-semibold p-[0_8px] flex items-center sm:gap-2 gap-1'>
                        <FaFilter className='text-gray-700 text-[12px]' />Filter
                    </button>
                </PopoverHandler>
                <PopoverContent className='max-w-[250px] p-0 w-full'>
                    <div className='p-[8px] flex justify-between items-center bg-[#f6fafa] text-[#687385] border-b-[1px] border-[#ebeef1]'>
                        <button className="h-[26px] input_focus_shadow rounded-[6px] bg-white text-[13px] font-medium p-[0_8px]" onClick={handleRemove}>Clear</button>
                        <span className='text-[15px] text-[#414552] font-medium'>Filters</span>
                        <button onClick={() => setOpenPopover(false)} className="border-[2px] h-[26px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[13px] font-medium p-[0_8px]">Done</button>
                    </div>
                    <div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="price" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.price} value={data.price} onChange={() => setData({ ...data, price: !data.price })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="price" className="cursor-pointer select-none font-medium text-[#414552]">Price</label>
                                    </div>
                                </div>
                            </div>
                            {data.price &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="relative w-full">
                                        <select className="input_focus_shadow text-[#404452] font-medium px-2 pr-5 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[13px] appearance-none">
                                            <option value="price_1NOemxSH60np6AHNflSe3Kx1">price_1NOemxSH60np6AHNflSe3Kx1</option>
                                            <option value="price_1NGHzcSH60np6AHNeaBHgGti">price_1NGHzcSH60np6AHNeaBHgGti</option>
                                        </select>
                                        <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[22px]' />
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="created" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.created} value={data.created} onChange={() => setData({ ...data, created: !data.created })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="created" className="cursor-pointer select-none font-medium text-[#414552] ">Created date</label>
                                    </div>
                                </div>
                            </div>
                            {data.created &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="flex items-center gap-2">
                                        <div className="relative w-full">
                                            <select className="input_focus_shadow text-[#404452] px-3 w-full bg-white rounded-[6px] font-medium focus:outline-none h-[24px] text-[13px] appearance-none">
                                                <option value="is in the last">is in the last</option>
                                                <option value="is equal to">is equal to</option>
                                                <option value="is between">is between</option>
                                                <option value="is after">is after</option>
                                                <option value="is on or after">is on or after</option>
                                                <option value="is before">is before</option>
                                                <option value="is before or on">is before or on</option>
                                            </select>
                                            <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[22px]" />
                                        </div>
                                    </div>
                                    <div className="flex gap-4 mt-2 items-center">
                                        <ArrowReturnIcon />
                                        <div className="flex gap-2 items-center w-full">
                                            <input type="text" className="input_focus_shadow text-[#404452] font-normal px-3 w-[60px] bg-white rounded-[6px] focus:outline-none h-[24px] text-[14px]" />
                                            <div className="relative mt-1 w-[100px]">
                                                <select className="input_focus_shadow text-[#404452] font-normal px-3 w-full bg-white rounded-[6px] focus:outline-none h-[24px] text-[14px] appearance-none">
                                                    <option value="days">days</option>
                                                    <option value="month">month</option>
                                                </select>
                                                <HiChevronUpDown className="absolute top-[2px] right-0 flex items-center pr-1 text-[20px]" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex gap-4 mt-2 items-center">
                                        <span className="w-max text-xs">Time zone:</span>
                                        <div className="flex gap-2 items-center">
                                            <div className="relative flex items-center">
                                                <div className="flex items-center">
                                                    <input id="zone-1" name="Time-zone" type="radio" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" defaultChecked />
                                                </div>
                                                <div className="ml-2 text-sm">
                                                    <label htmlFor="zone-1" className="select-none font-medium">
                                                        GMT+5:30
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="relative flex items-center">
                                                <div className="flex items-center">
                                                    <input id="zone-2" name="Time-zone" type="radio" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" />
                                                </div>
                                                <div className="ml-2 text-sm">
                                                    <label htmlFor="zone-2" className="select-none font-medium">
                                                        UTC
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="Status" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.status} value={data.status} onChange={() => setData({ ...data, status: !data.status })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="Status" className="cursor-pointer select-none font-medium text-[#414552]">Status</label>
                                    </div>
                                </div>
                            </div>
                            {data.status &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="relative w-full">
                                        <select className="input_focus_shadow text-[#404452] font-medium px-2 pr-5 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[13px] appearance-none">
                                            <option value="trialing">Trialing</option>
                                            <option value="active">Active</option>
                                            <option value="past_due">Past due</option>
                                            <option value="unpaid">Unpaid</option>
                                            <option value="canceled">Canceled</option>
                                            <option value="incomplete">Incomplete</option>
                                            <option value="incomplete_expired">Expired</option>
                                            <option value="ended">Ended</option>
                                            <option value="all">Any of the above</option>
                                        </select>
                                        <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[22px]' />
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="Method" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.method} value={data.method} onChange={() => setData({ ...data, method: !data.method })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="Method" className="cursor-pointer select-none font-medium text-[#414552]">Collection method</label>
                                    </div>
                                </div>
                            </div>
                            {data.method &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="relative w-full">
                                        <select className="input_focus_shadow text-[#404452] font-medium px-2 pr-5 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[13px] appearance-none">
                                            <option value="Charged to payment method on file">Charged to payment method on file</option>
                                            <option value="Emailed to customer">Emailed to customer</option>
                                        </select>
                                        <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[22px]' />
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="cStatus" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.cStatus} value={data.cStatus} onChange={() => setData({ ...data, cStatus: !data.cStatus })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="cStatus" className="cursor-pointer select-none font-medium text-[#414552]">Collection status</label>
                                    </div>
                                </div>
                            </div>
                            {data.cStatus &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="relative w-full">
                                        <select className="input_focus_shadow text-[#404452] font-medium px-2 pr-5 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[13px] appearance-none">
                                            <option value="Collection paused">Collection paused</option>
                                            <option value="Collection ongoing">Collection ongoing</option>
                                        </select>
                                        <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[22px]' />
                                    </div>
                                </div>
                            }
                        </div>
                        <div>
                            <div className='border-b-[1px] border-[#ebeef1] p-[8px_10px]'>
                                <div className="relative flex items-center">
                                    <div className="flex items-center">
                                        <input id="autoTax" name="filter" type="checkbox" className="h-[14px] w-[14px] rounded border-gray-300 accent-indigo-600 focus:outline-none" checked={data.autoTax} value={data.autoTax} onChange={() => setData({ ...data, autoTax: !data.autoTax })} />
                                    </div>
                                    <div className="ml-3 text-sm translate-y-[1px]">
                                        <label htmlFor="autoTax" className="cursor-pointer select-none font-medium text-[#414552]">Automatic Tax</label>
                                    </div>
                                </div>
                            </div>
                            {data.autoTax &&
                                <div className='bg-[#f6fafa] border-b-[1px] border-[#ebeef1] p-[12px]'>
                                    <div className="relative w-full">
                                        <select className="input_focus_shadow text-[#404452] font-medium px-2 pr-5 w-full bg-white rounded-[6px] focus:outline-none h-[26px] text-[13px] appearance-none">
                                            <option value="Enabled">Enabled</option>
                                            <option value="Disabled">Disabled</option>
                                        </select>
                                        <HiChevronUpDown className='absolute top-[2px] right-0 flex items-center pr-1 text-[22px]' />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </PopoverContent>
            </Popover>
        </div>
    )
}

export default SubsFilterMenu